module.exports = __webpack_public_path__ + "static/img/legend_xa_vertical.9f28cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_vertical.png
// module id = 4Dgi
// module chunks = 94